import React from 'react';

/**
 * Double Arrow Icon Component
 *
 * Renders two horizontal arrows stacked vertically:
 * - Top arrow points left (←)
 * - Bottom arrow points right (→)
 *
 * Used in NavigationLayoutToggle (explicit color) and AccountNavButton (CSS currentColor).
 * Pass color to override; omit to use currentColor for CSS-controlled styling.
 */
const DoubleArrowIcon: React.FC<{ color?: string, size?: number }> = ({ color = 'currentColor', size = 24 }) => {
	return (
		<svg
			fill="none"
			height={size}
			viewBox="0 0 24 24"
			width={size}
			xmlns="http://www.w3.org/2000/svg"
		>
			{/* Top arrow pointing left - centered at x=12, y=8 */}
			<path
				d="M6 5L4 8L6 11"
				fill="none"
				stroke={color}
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
			/>
			<path
				d="M4 8h16"
				stroke={color}
				strokeLinecap="round"
				strokeWidth="2"
			/>
			{/* Bottom arrow pointing right - centered at x=12, y=16 */}
			<path
				d="M18 19L20 16L18 13"
				fill="none"
				stroke={color}
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
			/>
			<path
				d="M4 16h16"
				stroke={color}
				strokeLinecap="round"
				strokeWidth="2"
			/>
		</svg>
	);
};

export default DoubleArrowIcon;
